// extracted by mini-css-extract-plugin
export var container = "_6j-0";
export var infoButton = "_6j-1";
export var label = "_6j-3";
export var labelExpanded = "_6j-4";
export var price = "_6j-5";
export var priceExpanded = "_6j-6";
export var title = "_6j-2";